@if (isBasicLayout()) {
  <router-outlet></router-outlet>
} @else {
  @if (loginTemplate === 'main') {
  <header class="core-toolbar no-print">
    <vdo-header></vdo-header>
  </header>
}

<mat-sidenav-container class="core-container"
                       *ngIf="sidenavConfig$Get() | async as config"
                       [hasBackdrop]="config.matSidenavConfig.hasBackdrop">

  @if (loginTemplate === 'main') {
    <mat-sidenav class="core-sidenav"
                 [fixedInViewport]="true"
                 [style.width.px]="isOpen ? 240 : 56"
                 [style.top.px]="64"
                 [mode]="config?.matSidenavConfig?.mode || 'side'"
                 [opened]="config?.matSidenavConfig?.open"
                 [disableClose]="true"
                 (keydown.escape)="$event.stopPropagation()"
    >

      <vdo-sidebar [compact]="config?.appSidebarConfig?.compact || false" class="no-print"
                   (toggleSidebar)="toggleGet()"></vdo-sidebar>
    </mat-sidenav>
  }

  <mat-sidenav-content class="core-content"
                       [style.margin-left.px]="loginTemplate === 'empty' ? 0 : isOpen ? 240 : 56"
                       [style.background-color]="coreBackgroundColor() || null">

    <router-outlet></router-outlet>

  </mat-sidenav-content>

</mat-sidenav-container>
}
